import { authClient } from "./web";

export const getUserInfo = authClient.getUserProfile;

export const checkAuth = authClient.checkAuth;
